
import api from "./axiosInterceptor.js"


export default async function GetData(url) {
    try {
        const response = await api.get(`api/${url}`)
        if (response.status === 200) {
            return { getData: response.data, error: false, load: false }

        } else if (response.status === 401) {
            return { getData: null, error: true, load: false }
        } else {
            throw response
        }

    } catch (err) {
        console.log(err)
        return { getData: null, error: err, load: false }
    }
}